/**
 * Tiny motivating "keep swiping" lines shown per card. 30 of them; a card gets a
 * stable-but-varied one (hashed by id) so it doesn't flicker on re-render but
 * differs card to card. Purpose: a gentle nudge toward the next snippet.
 */
export const READING_HOOKS: string[] = [
  "One more, you've got this",
  "The next one's a good one",
  "Curiosity loading…",
  "Don't stop now",
  "Keep the streak alive",
  "You're on a roll",
  "Just one more snip",
  "The good stuff is ahead",
  "Stay curious",
  "Plot twist incoming",
  "Knowledge, one swipe away",
  "Your brain says: more",
  "Tiny read, big payoff",
  "Feed your curiosity",
  "Worth the swipe, promise",
  "Future-you will thank you",
  "Smarter in 30 seconds",
  "Next card, next idea",
  "You came this far…",
  "Momentum is everything",
  "Don't break the chain",
  "One snip closer to caught up",
  "Quick win ahead",
  "Stay in the know",
  "Swipe for what's next",
  "Curiosity, rewarded",
  "Keep the good ideas coming",
  "Almost too easy",
  "Two minutes, ten smarter takes",
  "Onwards, curious one",
];

/** Stable-but-varied hook for a card (hashed by id), so it differs per card. */
export function hookForCard(seed: string | number): string {
  const s = String(seed);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return READING_HOOKS[h % READING_HOOKS.length];
}
